import React from 'react';
import { bool } from 'prop-types';
import Chip from '@mui/material/Chip';

const LoadableChip = ({ loadingAllowed }) => (
  <Chip
    label={loadingAllowed ? 'Loadable' : 'Not Loadable'}
    sx={{
      backgroundColor: loadingAllowed ? 'secondary.light' : 'error.light',
      color: loadingAllowed ? 'secondary.dark' : 'error.dark',
      fontFamily: 'Overpass',
      height: '24px',
      ml: 2,
      pt: '1px',
    }}
    variant="subtitle2"
  />
);

LoadableChip.propTypes = {
  loadingAllowed: bool.isRequired,
};

export default LoadableChip;
